import { useRouter } from 'next/router'
import { useEffect } from 'react'

import { useAlert } from '@hooks/useAlert'

interface ErrorMessageProps {
  message: string
  redirectUrl?: string
}

export function ErrorMessage({ message, redirectUrl }: ErrorMessageProps) {
  const alert = useAlert()
  const router = useRouter()
  useEffect(() => {
    alert.error(message)

    if (redirectUrl) {
      router.replace(redirectUrl)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return null
}
